import { CalendarCheck, MessageCircle } from "lucide-react";
import { toast } from "sonner";

export const FinalCTA = () => (
    <section aria-label="Book your consultation" className="bg-slate-900 relative overflow-hidden">
        <div className="pointer-events-none absolute top-0 right-0 h-80 w-80 rounded-full bg-teal-600/15 blur-3xl" aria-hidden="true" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24 text-center">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-white">
                Take the First Step Toward a Healthier Smile.
            </h2>
            <p className="mt-5 text-base sm:text-lg leading-relaxed text-slate-300 max-w-xl mx-auto">
                Book your dental consultation and take the next step toward better oral health.
            </p>
            <div className="mt-9 flex flex-wrap justify-center gap-4">
                <a
                    href="#appointment"
                    data-testid="final-cta-book-btn"
                    className="inline-flex items-center gap-2 rounded-full bg-teal-600 px-8 py-4 text-base font-semibold text-white shadow-[0_12px_30px_rgba(13,148,136,0.45)] transition-all duration-200 hover:bg-teal-500 hover:-translate-y-0.5"
                >
                    <CalendarCheck className="h-5 w-5" />
                    Book Appointment
                </a>
                <button
                    type="button"
                    data-testid="final-cta-whatsapp-btn"
                    onClick={() => toast.info("WhatsApp chat will be connected in the next update.")}
                    className="inline-flex items-center gap-2 rounded-full border border-slate-600 px-8 py-4 text-base font-semibold text-white transition-all duration-200 hover:border-teal-400 hover:text-teal-300 hover:-translate-y-0.5"
                >
                    <MessageCircle className="h-5 w-5" />
                    WhatsApp Clinic
                </button>
            </div>
        </div>
    </section>
);
